import { useEffect } from 'react';
import { isSupabaseConfigured } from '../lib/supabase';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export function useReminderChecker() {
  useEffect(() => {
    if (!isSupabaseConfigured) {
      return;
    }

    const checkAndProcessReminders = async () => {
      try {
        const response = await fetch(
          `${SUPABASE_URL}/functions/v1/process-scheduled-reminders`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          if (data.processed > 0) {
            console.log(`Processed ${data.processed} reminders`);
          }
        }
      } catch (error) {
        console.error('Error checking reminders:', error);
      }
    };

    checkAndProcessReminders();

    const interval = setInterval(checkAndProcessReminders, 60000);

    return () => clearInterval(interval);
  }, []);
}
